type MaybePromise<T> = T | Promise<T>;

const toErrorName = (error: unknown): string => {
  if (!error || typeof error !== 'object') return '';
  const value = (error as { name?: unknown }).name;
  return typeof value === 'string' ? value : '';
};

const toErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object') {
    const value = (error as { message?: unknown }).message;
    return typeof value === 'string' ? value : '';
  }
  return '';
};

export const isExpectedNotificationNavigationAbort = (error: unknown): boolean => {
  const name = toErrorName(error).toLowerCase();
  const message = toErrorMessage(error).toLowerCase();

  if (name === 'aborterror' || message.includes('aborterror')) {
    return true;
  }

  return message.includes('transition')
    && (
      message.includes('abort')
      || message.includes('cancel')
      || message.includes('interrupted')
      || message.includes('superseded')
    );
};

export const handleNotificationNavigationError = (
  source: string,
  error: unknown,
): void => {
  if (isExpectedNotificationNavigationAbort(error)) {
    return;
  }
  console.warn(source, error);
};

export const runSafeNotificationNavigation = async (
  action: () => MaybePromise<void>,
  source: string,
): Promise<void> => {
  try {
    await action();
  } catch (error) {
    handleNotificationNavigationError(source, error);
  }
};
